// Popup landing page after LinkedIn OAuth — broadcasts session to main window then closes itself.
// Must be on same origin (localhost:3001) for window.close() to work.
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function LinkedInOAuthClose() {
  const [params] = useSearchParams();

  useEffect(() => {
    const sessionId = params.get('session_id');
    const name      = params.get('name') || 'LinkedIn User';

    try {
      const channel = new BroadcastChannel('postflow_oauth');
      channel.postMessage({
        type: 'oauth_linkedin_pages',
        sessionId,
        profile: { name, avatar: null, email: '' },
        pages: [],
      });
      channel.close();
    } catch (e) {
      // BroadcastChannel not supported — try postMessage fallback
      try {
        if (window.opener) {
          window.opener.postMessage({
            type: 'oauth_linkedin_pages',
            sessionId,
            profile: { name, avatar: null, email: '' },
            pages: [],
          }, window.location.origin);
        }
      } catch (e2) { /* ignore */ }
    }

    // Small delay so the broadcast is received before close
    const t = setTimeout(() => window.close(), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', textAlign: 'center', paddingTop: 80, background: '#f5f6fa', height: '100vh', color: '#1a1f2e' }}>
      <div style={{ fontSize: 52 }}>✅</div>
      <h2 style={{ fontSize: 20, fontWeight: 700, margin: '12px 0 8px' }}>LinkedIn Authorized</h2>
      <p style={{ fontSize: 13, color: '#5a6578' }}>Select the page to connect in Post Calendar.</p>
      <p style={{ color: '#aaa', fontSize: 11, marginTop: 16 }}>This window will close automatically…</p>
    </div>
  );
}
